import {
  PUSH_PRODUCT_COMPARE,
  POP_PRODUCT_COMPARE,
  SET_COMPARE_DATA,
  CLEAR_COMPARE,
  OPEN_COMPARE,
  TOGGLE_SHOW_DIFFERENCES,
} from '@/context/compare/types';
import cleanState from '@/context/compare/state';

import { deselectCompareProduct } from '@/utils/Common/ListingUtils';

export default (state, action) => {
  switch (action.type) {
    case PUSH_PRODUCT_COMPARE: {
      const { materialGroup, productCode, push } = action.payload;
      if (state.productsCode.length === 1 && !push) {
        return {
          ...state,
          ...cleanState,
        };
      }

      return {
        ...state,
        productsCode: push
          ? [...state.productsCode, productCode]
          : state.productsCode.filter(code => code !== productCode),
        materialGroup,
        compareVisible: true,
      };
    }
    case POP_PRODUCT_COMPARE: {
      const { materialGroup, productCode } = action.payload;
      deselectCompareProduct(productCode);
      if (state.productsCode.length === 1) {
        return {
          ...state,
          ...cleanState,
        };
      }

      return {
        ...state,
        productsCode: state.productsCode.filter(code => code !== productCode),
        materialGroup,
      };
    }
    case SET_COMPARE_DATA:
      return {
        ...state,
        compareData: action.payload,
        compareDataReady: true,
        productsCount: state.productsCode.length,
      };
    case CLEAR_COMPARE:
      return {
        ...state,
        ...cleanState,
      };
    case OPEN_COMPARE:
      return { ...state, compareOpen: action.payload };
    case TOGGLE_SHOW_DIFFERENCES:
      return { ...state, showDifferences: !state.showDifferences };
    default:
      return { ...state };
  }
};
